import { render, staticRenderFns } from "./CompanyLoadsPopup.vue?vue&type=template&id=4cc6e07a&scoped=true"
import script from "./CompanyLoadsPopup.vue?vue&type=script&lang=js"
export * from "./CompanyLoadsPopup.vue?vue&type=script&lang=js"
import style0 from "./CompanyLoadsPopup.vue?vue&type=style&index=0&id=4cc6e07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc6e07a",
  null
  
)

export default component.exports